import React, { FC, useEffect } from 'react';

import { ChevronLeft, ChevronRight } from 'lucide-react';

type IProps = {
    perPageData: number;
    total: number;
    length: number;
    currentPage: number;
    changePage: (page: string) => void;
};

const Pagination: FC<IProps> = ({ perPageData, total, currentPage, changePage, length }) => {
    const pageNumbers = [];
    const totalPages = Math.ceil(total / perPageData);
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const maxPagesToShow = 20;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    const visiblePages = pageNumbers.slice(startPage - 1, endPage);

    const handleChangePage = (p: string) => {
        changePage(p);
    };

    const handlePrevPage = () => {
        const prevPage = currentPage - 1;
        changePage(prevPage as unknown as string);
    };

    const handleNextPage = () => {
        const nextPage = currentPage + 1;
        changePage(nextPage as unknown as string);
    };

    return (
        <React.Fragment>
            <div className="my-5 flex w-full flex-col items-center rounded-md bg-white px-3.5 py-2.5">
                <div className="mb-4 grow">
                    <p className="text-slate-500">
                        Showing <b>{length}</b> of <b>{total}</b> Results
                    </p>
                </div>
                <ul className="flex shrink-0 flex-wrap items-center gap-2">
                    {currentPage > 1 && (
                        <li>
                            <button
                                className="inline-flex h-8 cursor-pointer items-center justify-center rounded border border-slate-200 bg-white px-3 text-slate-500 transition-all duration-150 ease-linear hover:bg-custom-100 hover:text-custom-500 focus:bg-custom-50  focus:text-custom-500"
                                onClick={handlePrevPage}
                            >
                                <ChevronLeft className="mr-1 size-4 rtl:rotate-180" /> Prev
                            </button>
                        </li>
                    )}
                    {visiblePages.map((p) => (
                        <li
                            key={p}
                            className={
                                currentPage === p
                                    ? `active inline-flex h-8 cursor-pointer items-center justify-center rounded border border-slate-200 bg-white px-3 text-slate-500 transition-all duration-150 ease-linear hover:bg-custom-100 hover:text-custom-500  focus:bg-custom-50  focus:text-custom-500 [&.active]:border-custom-500 [&.active]:bg-custom-500  [&.active]:text-white [&.active]:hover:text-white [&.disabled]:cursor-auto [&.disabled]:text-slate-400`
                                    : `inline-flex h-8 cursor-pointer items-center justify-center rounded border border-slate-200 bg-white px-3 text-slate-500 transition-all duration-150 ease-linear hover:bg-custom-100 hover:text-custom-500 focus:bg-custom-50  focus:text-custom-500  [&.active]:border-custom-500 [&.active]:bg-custom-500 [&.active]:text-white  [&.active]:hover:text-white [&.disabled]:cursor-auto [&.disabled]:text-slate-400`
                            }
                            onClick={() => handleChangePage(p as unknown as string)}
                        >
                            {p}
                        </li>
                    ))}

                    {currentPage < totalPages && (
                        <li>
                            <button
                                className="inline-flex h-8 cursor-pointer items-center justify-center rounded border border-slate-200 bg-white px-3 text-slate-500 transition-all duration-150 ease-linear hover:bg-custom-100 hover:text-custom-500 focus:bg-custom-50  focus:text-custom-500"
                                onClick={handleNextPage}
                            >
                                Next <ChevronRight className="ml-1 size-4 rtl:rotate-180" />
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </React.Fragment>
    );
};

export default Pagination;
